import { TemplateMail } from "domain/entities/template-mail";
import { EMAIL } from "domain/enum/email";
import { BaseInputFilter } from "domain/models/base-input-filter";
import DropdownComponent from "presentation/components/Shared/DropdownComponent";
import InputTextComponent from "presentation/components/Shared/InputTextComponent";
import { useParameterByFilter } from "presentation/hooks/use-query-parameter";
import { useUpdateTemplateMailMutation } from "presentation/hooks/use-query-template-mail";
import { useAuthStore } from "presentation/stores/use-auth-store";
import { useParameterStore } from "presentation/stores/use-parameter-store";
import { useTemplateMailStore } from "presentation/stores/use-template-mail-store";
import { Button } from "primereact/button";
import { Editor } from "primereact/editor";
import { Toast } from "primereact/toast";
import { useEffect, useRef, useState } from "react";

interface ParamProps {
  // templateMail: TemplateMail;
  onClose: () => void;
}
const NotificationForm: React.FC<ParamProps> = (params: ParamProps) => {
  const toast = useRef<Toast>(null);
  const [text, setText] = useState("");
  const { templateMail, setTemplateMail } = useTemplateMailStore();
  const { objectType, setObjectType } = useParameterStore();
  const { email: userEmployeeEmail, userPermissions } = useAuthStore();

  const { mutateAsync: updateTemplateMail } = useUpdateTemplateMailMutation();

  // console.log(templateMail);

  const renderHeader = () => {
    return (
      <span className="ql-formats">
        <select className="ql-font">
          <option value=""></option>
          <option value="serif"></option>
          <option value="monospace"></option>
        </select>
        <select className="ql-size">
          <option value="small"></option>
          <option value=""></option>
          <option value="large"></option>
          <option value="huge"></option>
        </select>
        <button className="ql-bold" aria-label="Bold"></button>
        <button className="ql-italic" aria-label="Italic"></button>
        <button className="ql-underline" aria-label="Underline"></button>
        <select className="ql-color"></select>
        <button
          className="ql-list"
          value="ordered"
          aria-label="Ordered List"
        ></button>
        <button
          className="ql-list"
          value="bullet"
          aria-label="Unordered List"
        ></button>
      </span>
    );
  };

  const header = renderHeader();

  const saveTemplateMail = () => {
    if (templateMail) {
      templateMail.lastModifiedBy = userEmployeeEmail || EMAIL;
      updateTemplateMail(templateMail).then(() => {
        console.log("Template Mail Saved");
        params.onClose();
      });
    }
  };

  return (
    <div className="parameter-grid header-spacing">
      <div className="parameter-1-col">
        <DropdownComponent
          fieldName={"object"}
          options={objectType}
          isDisable={true}
          label={"Tipo de Objeto"}
          currentObject={templateMail}
          getValue={templateMail?.object}
          setValue={setTemplateMail}
        />
      </div>
      <div className="parameter-3-cols">
        <InputTextComponent
          fieldName={"name"}
          label={"Nome"}
          isDisable={true}
          currentObject={templateMail}
          getValue={templateMail?.name}
          setValue={setTemplateMail}
        />
      </div>

      <div className="parameter-4-cols">
        <InputTextComponent
          fieldName={"subject"}
          label={"Assunto"}
          currentObject={templateMail}
          getValue={templateMail?.subject}
          setValue={setTemplateMail}
        />
      </div>
      <div className="parameter-4-cols">
        <label htmlFor={"Content"} className="label">
          {"Mensagem"}
        </label>
        <Editor
          name="Content"
          value={templateMail?.content ?? ""}
          onTextChange={(e) =>
            setTemplateMail({ ...templateMail, content: e.htmlValue ?? "" })
          }
          style={{ height: "250px" }}
          headerTemplate={header}
          className="pt2"
        />
      </div>
      <div className="parameter-4-cols next-button pt-0 mt-0">
        <Button
          onClick={saveTemplateMail}
          label="Guardar"
          className="button-size m0"
        />
      </div>
    </div>
  );
};
export default NotificationForm;
